import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function VoteButton({ videoId, compact = false }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [voted, setVoted] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/awards/my-votes")
      .then((r) => setVoted((r.data?.video_ids || []).includes(videoId)))
      .catch(() => {});
  }, [user, videoId]);

  const toggle = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!user) { toast.info("Sign in to vote"); return nav("/login"); }
    setBusy(true);
    try {
      const { data } = await api.post(`/videos/${videoId}/vote`);
      setVoted(!!data.voted);
      toast.success(data.voted ? "Voted for the Tap In Creator Awards" : "Vote removed");
    } catch { toast.error("Vote failed"); }
    finally { setBusy(false); }
  };

  if (compact) {
    return (
      <button
        data-testid={`vote-btn-${videoId}`}
        onClick={toggle}
        disabled={busy}
        title="Vote for Tap In Creator Awards"
        className={`w-8 h-8 rounded-full flex items-center justify-center transition ${voted ? "bg-tv-accent text-black" : "bg-black/50 text-white/90 hover:bg-black/70"}`}
      >
        <Trophy className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      data-testid={`vote-btn-${videoId}`}
      onClick={toggle}
      disabled={busy}
      className={`px-4 py-2 rounded-full flex items-center gap-2 font-semibold text-sm transition ${voted ? "bg-tv-accent text-black" : "tv-glass text-white hover:bg-white/10 border border-white/15"}`}
    >
      <Trophy className="w-4 h-4" /> {voted ? "Voted" : "Vote for Awards"}
    </button>
  );
}
